// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2185":"c8e672736d80df3f35d3","3732":"20e0903bf6514ca57b76","8278":"e69253f608fd6c73d936"}[chunkId] + ".js";
};